import { QuickplayErrors } from '../api';

export const handleQuickPlayError = (errors?: QuickplayErrors) => {
  if (!errors || !errors.length) {
    return;
  }
  const [error] = errors;
  throw new Error(error?.description || String(error));
};
